import { Ticket, Site, User } from '../types';

const STORAGE_KEYS = {
    TICKETS: 'adidas_tickets',
    SITES: 'adidas_sites',
    USERS: 'adidas_users',
    CURRENT_USER: 'adidas_current_user',
};

export class StorageService {
    // Tickets
    static saveTickets(tickets: Ticket[]): void {
        try {
            localStorage.setItem(STORAGE_KEYS.TICKETS, JSON.stringify(tickets));
        } catch (error) {
            console.error('Error saving tickets:', error);
        }
    }

    static loadTickets(): Ticket[] {
        try {
            const data = localStorage.getItem(STORAGE_KEYS.TICKETS);
            if (!data) return [];

            const tickets = JSON.parse(data);
            // Convert date strings back to Date objects
            return tickets.map((t: any) => ({
                ...t,
                createdAt: new Date(t.createdAt),
                updatedAt: new Date(t.updatedAt),
                slaDue: new Date(t.slaDue),
                timeline: t.timeline.map((e: any) => ({
                    ...e,
                    timestamp: new Date(e.timestamp),
                })),
            }));
        } catch (error) {
            console.error('Error loading tickets:', error);
            return [];
        }
    }

    // Sites
    static saveSites(sites: Site[]): void {
        try {
            localStorage.setItem(STORAGE_KEYS.SITES, JSON.stringify(sites));
        } catch (error) {
            console.error('Error saving sites:', error);
        }
    }

    static loadSites(): Site[] {
        try {
            const data = localStorage.getItem(STORAGE_KEYS.SITES);
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error('Error loading sites:', error);
            return [];
        }
    }

    // Users
    static saveUsers(users: User[]): void {
        try {
            localStorage.setItem(STORAGE_KEYS.USERS, JSON.stringify(users));
        } catch (error) {
            console.error('Error saving users:', error);
        }
    }

    static loadUsers(): User[] {
        try {
            const data = localStorage.getItem(STORAGE_KEYS.USERS);
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error('Error loading users:', error);
            return [];
        }
    }

    // Current User
    static saveCurrentUser(user: User | null): void {
        try {
            if (user) {
                localStorage.setItem(STORAGE_KEYS.CURRENT_USER, JSON.stringify(user));
            } else {
                localStorage.removeItem(STORAGE_KEYS.CURRENT_USER);
            }
        } catch (error) {
            console.error('Error saving current user:', error);
        }
    }

    static loadCurrentUser(): User | null {
        try {
            const data = localStorage.getItem(STORAGE_KEYS.CURRENT_USER);
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error('Error loading current user:', error);
            return null;
        }
    }

    // Clear all data
    static clearAll(): void {
        Object.values(STORAGE_KEYS).forEach((key) => {
            localStorage.removeItem(key);
        });
    }
}
